export default "__VITE_ASSET__Dkyj4mmr__"